import { Breadcrumb } from 'antd';
import { LayoutCMS } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import TableUsers from './libraries';

export const PageUsersComponent = (props: any) => {
    const title = 'Users';
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    <Link to="/user/users">{title}</Link>
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };
    return (
        <LayoutCMS {...layoutCMSProps}>
            <TableUsers />
        </LayoutCMS>
    );
};

export default PageUsersComponent;



// WEBPACK FOOTER //
// ./src/pages/users/component.tsx